document.addEventListener('DOMContentLoaded', () => {
	let resourceGridSections = document.querySelectorAll('section.resources-grid')

	const calcHeights = () => {
		resourceGridSections?.forEach(section => {
			let resourceGrid = section.querySelector('.resource-grid')
			let collapsableWrapper = section.querySelector('.collapsable-wrapper')
			let limit = window.innerWidth < 768 || window.innerWidth >= 1200 ? 3 : 2
			let resources = Array.from(
				collapsableWrapper.querySelectorAll('.resource')
			).slice(0, limit)

			let collapsedHeight = 0
			let expandedHeight = 0

			resourceGrid.setAttribute(
				'style',
				`--expanded-height: auto; --collapsed-height: auto;`
			) // This part is necessary to actually recalculate the tallest .visible element on window resize
			expandedHeight = collapsableWrapper.scrollHeight
			resources.forEach(resource => {
				if (window.innerWidth < 768) {
					collapsedHeight += resource.scrollHeight
				} else {
					collapsedHeight =
						resource.scrollHeight > collapsedHeight
							? resource.scrollHeight
							: collapsedHeight
				}
			})

			resourceGrid.setAttribute(
				'style',
				`--expanded-height: ${expandedHeight}px; --collapsed-height: ${collapsedHeight}px;`
			)
		})
	}

	calcHeights()

	window.addEventListener('resize', calcHeights)

	let seeMoreButts = document.querySelectorAll(
		'section.resources-grid .see-more'
	)
	seeMoreButts.forEach(butt => {
		butt.addEventListener('click', () => {
			butt.closest('.resource-grid').classList.add('expanded')
		})
	})
})
